<template>
  <div class="replaced">
    <div v-if="loading" class="replaced__loading"><v-progress-circular indeterminate size="18" width="2" /> Vorgänger laden…</div>
    <div v-else-if="!items.length" class="replaced__hint">Vorgänger-Tasks nicht mehr vorhanden.</div>
    <div v-else class="replaced__grid">
      <div v-for="p in items" :key="'pred-' + p.data.id" class="replaced__col">
        <div class="replaced__meta">
          <span class="replaced__chip">ersetzt → {{ p.change.to }}</span>
          <span class="replaced__date">{{ p.change.at ? formatDate(p.change.at) : "" }}</span>
          <span v-if="p.change.sameArtwork" class="replaced__date">nur Text/Layout geändert</span>
        </div>
        <TaskDetailsCard v-if="p.type === 'task'" :task="p.data" />
        <ImportLiveTaskCard v-else :task="p.data" />
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Vom Kunden über den Änderungslink ersetzte Tasks (orders.artworkChangedByCustomer[]).
 * Sie hängen nicht mehr an orders.tasks, bleiben aber zur Nachvollziehbarkeit erhalten
 * (Status CANCELED + replacedBy) — hier als eigene Karte unter den aktiven Tasks.
 */
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../../fb";
import dayjs from "dayjs";
import TaskDetailsCard from "@/components/TaskCards/TaskDetailsCard";
import ImportLiveTaskCard from "@/components/TaskCards/ImportLiveTaskCard";

export default {
  name: "ReplacedTasks",
  components: { TaskDetailsCard, ImportLiveTaskCard },
  props: {
    changes: { type: Array, default: () => [] },
  },
  data() {
    return { loading: false, items: [] };
  },
  watch: {
    changes: { immediate: true, handler: "load" },
  },
  methods: {
    formatDate(ms) {
      return dayjs(Number(ms)).format("DD.MM.YYYY HH:mm");
    },
    async load() {
      this.loading = true;
      const out = [];
      try {
        // neueste Änderung zuerst
        const list = [...(this.changes || [])].sort((a, b) => Number(b.at || 0) - Number(a.at || 0));
        for (const change of list) {
          const uid = change && change.from;
          if (!uid) continue;
          for (const [col, type] of [["tasks", "task"], ["shopifyTasks", "shopifyTask"]]) {
            const snap = await getDoc(doc(db, `${col}/${uid}`));
            if (snap.exists()) {
              out.push({ type, data: { id: snap.id, ...snap.data() }, change });
              break;
            }
          }
        }
      } finally {
        this.items = out;
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.replaced {
  &__loading,
  &__hint {
    font-size: 13px;
    color: #777;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  &__grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 20px;
    opacity: 0.9;
  }
  &__meta {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 6px;
    font-size: 12px;
  }
  &__chip {
    font-size: 11px;
    font-weight: 700;
    border-radius: 999px;
    padding: 2px 10px;
    background: #f0f0f0;
    color: #777;
  }
  &__date {
    color: #888;
    font-size: 12px;
  }
}
</style>
